import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FileInfo, FileRestrictions, FileSelectComponent, RemoveEvent, SelectEvent } from '@progress/kendo-angular-upload';

@Component({
  selector: 'app-attach-documents',
  templateUrl: './attach-documents.component.html',
  styleUrls: ['./attach-documents.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: AttachDocumentsComponent,
    multi: true
  }]
})
export class AttachDocumentsComponent implements ControlValueAccessor, OnInit,AfterViewInit {

  initFilesToAttach:[];

  isDisabled:false;
  filesToAttach: Array<any>;
  @Input() fileRestrictions: FileRestrictions = {};
  @Output() fileSelected: EventEmitter<any[]> = new EventEmitter<any[]>();

  @ViewChild('fileSelectAttachDocs') fileSelectControl: FileSelectComponent;

  ngOnInit(): void {
    this.filesToAttach = [];
  }

  ngAfterViewInit(): void {
   
     this.fileSelectControl.addFiles(this.initFilesToAttach);
  }

  attachFile(attachments: FileInfo[]): void {
   
     this.fileSelectControl.addFiles(attachments);
  }
  


  public onSelect(ev: SelectEvent): void {
    const filesToRead = ev.files?.filter((file: FileInfo) => file.rawFile && !file.validationErrors);
    if (!filesToRead?.length) {
      return;
    }

    const fileReads = filesToRead.map((file: FileInfo) => new Promise<any>((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve({ ...file, src: <string>reader.result });
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(file.rawFile);
    }));

    Promise.all(fileReads).then((loadedFiles) => {
      const successfulFiles = loadedFiles.filter((file) => file !== null);
      if (!successfulFiles.length) {
        return;
      }

      this.filesToAttach.push(...successfulFiles);
      this.onChange(this.filesToAttach);
      this.fileSelected.emit(this.filesToAttach);
    });
  }

  public onRemove(ev: RemoveEvent): void {
    ev.files.forEach((file: FileInfo) => {
      this.filesToAttach = this.filesToAttach.filter((f) => f.uid !== file.uid);
      this.onChange(this.filesToAttach);
    });
  }

  onTouched = () => {};
  onChange = _ => {};

  writeValue(obj: any): void {
     this.initFilesToAttach = obj;

  }

  registerOnChange(fn: any): void {
     this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    
  }

}
